var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1587 18.6838C17.1587 16.856 18.1668 15.2723 19.6458 14.417C18.7204 14.121 17.7238 13.8865 16.6763 13.7231C18.927 12.4748 20.4521 10.0771 20.4521 7.31997C20.4521 3.27703 17.1751 0 13.1321 0C9.08918 0 5.81216 3.27703 5.81216 7.31997C5.81216 10.0761 7.33727 12.4748 9.58794 13.7231C4.05832 14.5852 0 17.4096 0 20.7654H17.6344C17.3375 20.1292 17.1587 19.4305 17.1587 18.6838Z",
    fill: "#818090"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1069 14.8235C19.9754 14.8235 18.2456 16.5504 18.2456 18.6848C18.2456 20.8173 19.9754 22.5452 22.1069 22.5452C24.2394 22.5452 25.9682 20.8173 25.9682 18.6848C25.9663 16.5495 24.2394 14.8235 22.1069 14.8235ZM24.6276 19.369H22.7931V21.2046H21.4217V19.369H19.5862V17.9958H21.4217V16.1593H22.7931V17.9958H24.6276V19.369Z",
    fill: "#818090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPeople);
export default __webpack_public_path__ + "static/media/AddPeople.4c972af1fdad75f98614fafbb93e02cd.svg";
export { ForwardRef as ReactComponent };